import { useState, useCallback, useRef } from "react"
import { fetchAgingReport } from "../api/collectionsApi"

export function useAgingReport() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const abortRef = useRef(null)

  const fetch = useCallback(async (filters = {}) => {
    if (abortRef.current) abortRef.current.abort()
    abortRef.current = new AbortController()

    setLoading(true)
    setError(null)
    try {
      const result = await fetchAgingReport(filters)
      setData(result)
    } catch (err) {
      if (err.name !== "AbortError") setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch, reload: fetch }
}
